"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkBaseUrlSlash = void 0;
const checkBaseUrlSlash = () => {
    const myAppSettingsObj = window["myAppSettings"];
    const baseUrl = myAppSettingsObj.REACT_APP_BASE_API_URL;
    if (baseUrl.slice(-1) === "/")
        return baseUrl;
    else
        return baseUrl + "/";
};
exports.checkBaseUrlSlash = checkBaseUrlSlash;
